// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"1238e5fc","832":"114df79a"}[chunkId] + ".chunk.css";
};